"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeCurrentSessionId = exports.getCurrentSessionId = exports.setCurrentSessionId = void 0;
/* eslint-disable no-undef */
const SESSION_ID_KEY = "sessionId";
const REMEMBER_ME_KEY = "rememberMe";
const getStorage = (name) => {
    try {
        const storage = globalThis[name];
        if (!storage) {
            return undefined;
        }
        storage.getItem(SESSION_ID_KEY);
        return storage;
    }
    catch {
        return undefined;
    }
};
/**
 * Writes the app session id. Remember-me sessions use localStorage so they
 * survive a browser restart; standard sessions use sessionStorage so they do not.
 *
 * Also co-writes the client-side `rememberMe` flag in localStorage. Downstream
 * code (inactivity timeout thresholds, password re-auth persistence) reads that
 * flag, so it must always agree with where the session id actually lives.
 */
const setCurrentSessionId = (sessionId, rememberMe = false) => {
    const persistent = getStorage("localStorage");
    const session = getStorage("sessionStorage");
    if (rememberMe) {
        persistent?.setItem(SESSION_ID_KEY, sessionId);
        session?.removeItem(SESSION_ID_KEY);
        persistent?.setItem(REMEMBER_ME_KEY, "true");
        return;
    }
    session?.setItem(SESSION_ID_KEY, sessionId);
    persistent?.removeItem(SESSION_ID_KEY);
    persistent?.removeItem(REMEMBER_ME_KEY);
};
exports.setCurrentSessionId = setCurrentSessionId;
/** Returns the tab session id if present, otherwise the remembered localStorage id. */
const getCurrentSessionId = () => {
    const session = getStorage("sessionStorage");
    const persistent = getStorage("localStorage");
    return session?.getItem(SESSION_ID_KEY) || persistent?.getItem(SESSION_ID_KEY) || "";
};
exports.getCurrentSessionId = getCurrentSessionId;
/** Removes the session id from both stores so sign-out cannot leave a stale id. */
const removeCurrentSessionId = () => {
    getStorage("sessionStorage")?.removeItem(SESSION_ID_KEY);
    getStorage("localStorage")?.removeItem(SESSION_ID_KEY);
};
exports.removeCurrentSessionId = removeCurrentSessionId;
//# sourceMappingURL=sessionIdStorage.js.map